module.exports = __webpack_public_path__ + "media/svgs/Pfeil-Icon-753da177a16d523c9915866f27277724.svg";